import React, { useCallback, useEffect, useState } from "react";
import {
  DownloadSimple,
  Scroll,
  TrashSimple,
  Plus,
  Pencil,
  List,
  ArrowsLeftRight,
} from "phosphor-react";
import TableWrapper from "components/common/table-wrapper";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import CustomModal from "components/common/modal";
import Addmemberform from "./Addmemberform";
import {
  createMember,
  getMembers,
  deleteBulkMember,
  getExportMembers,
  updateMember,
} from "containers/members/api";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";

import {
  highlightFirstMatch,
  formatDateDiff,
  capitalizeName,
} from "utils/common";

import Tooltip from "components/common/tooltip";
import { getTemplates } from "containers/templates/api";
import { useDebouncedTemplateDataCallback } from "utils/debouncedHelper";
import AsyncSelect from "components/common/select/AsyncSelect";

let timeout;

const SortableTableHeader = ({
  columnKey,
  label,
  sortConfig,
  onSortChange,
}) => {
  const isSorting = sortConfig.key === columnKey;
  const isAscending = isSorting && sortConfig.direction === "asc";
  const isDescending = isSorting && sortConfig.direction === "desc";

  const handleSort = () => {
    if (isAscending) {
      onSortChange(columnKey, "desc");
    } else {
      onSortChange(columnKey, "asc");
    }
  };

  return (
    <th onClick={handleSort} style={{ cursor: "pointer" }}>
      <div className="d-flex position-relative">
        <div className="d-flex flex-column cursor-pointer me-2 position-absolute top-50  end-100 translate-middle-y ">
          {/* <CaretUp size={12} color={isAscending ? '#000000' : '#00000050'} weight="fill" />
          <CaretDown color={isDescending ? '#000000' : '#00000050'} size={12} weight="fill" /> */}
        </div>
        <div>{label}</div>
      </div>
    </th>
  );
};
const columns = [
  { columnKey: "name", label: "Name", isSortable: true },
  { columnKey: "follow_up", label: "Follow Up Date", isSortable: true },
  { columnKey: "date_of_birth", label: "Date of Birth", isSortable: true },
  { columnKey: "cin", label: "CIN", isSortable: true },
  { columnKey: "city", label: "County", isSortable: false },
  { columnKey: "policy_name", label: "Policy", isSortable: true },
  // { columnKey: "account_number", label: "Policy", isSortable: true },
  { columnKey: "health_plan_name", label: "MIF", isSortable: false },
  { columnKey: "mif_status", label: "MIF Status", isSortable: false },
  {
    columnKey: "enrollment_status",
    label: "ECM Status",
    isSortable: false,
  },
  {
    columnKey: "survey_count",
    label: "Survey Count",
    isSortable: false,
  },
  { columnKey: "", label: "", isSortable: false },
  { columnKey: "", label: "", isSortable: false },
];
const Member = () => {
  const [membersList, setmembersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [templatesList, setTemplatesList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    mif_status: "active",
    perPage: "10",
  });
  const [loading, setLoading] = useState(true);
  const [selectedmembers, setSelectedmembers] = useState(0);
  const [selectedMember, setSelectedMember] = useState("");
  const [ismemberModalVisible, setmemberIsModalVisible] = useState(false);
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [selectedMemberForSurvey, setSelectedMemberForSurvey] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }));
    debounceFn(handleRefreshPage, DEBOUNCE_DELAY);
  };
  const handleSetMifFilter = (selectedValue) => {
    setMeta((prevMeta) => ({ ...prevMeta, mif_status: selectedValue }));
    handleRefreshPage();
  };
  const handlePageChange = (value) => {
    navigate({ search: createSearchParams({ page: value }).toString() });
    handleRefreshPage();
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const handlememberSubmission = async (member, setErrors) => {
    try {
      let result = "";
      if (selectedMember) {
        result = await updateMember(member, selectedMember.id, setErrors);
      } else result = await createMember(member, setErrors);
      if (result) {
        handleClosememberModal();
        handleRefreshPage();
      }
    } catch (error) {
      console.log("error is ", error);
    }
  };

  const handleSelectAll = () => {
    const updatedCheckboxes = membersList.map((checkbox) => ({
      ...checkbox,
      checked: !selectAll,
    }));
    setmembersList(updatedCheckboxes);
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (index) => {
    setmembersList((prevList) =>
      prevList.map((item, itemIndex) =>
        itemIndex === index ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleClosememberModal = () => {
    setmemberIsModalVisible(false);
    setSelectedMember("");
  };
  const handleBulkDeleteMembers = async () => {
    const selectedMemberIds = membersList
      ?.filter((member) => member.checked)
      .map((member) => member.id);
    const payload = {
      ids: selectedMemberIds,
    };
    const result = await deleteBulkMember(payload);
    if (result) handleRefreshPage();
  };

  const handleOpenmemberModal = () => {
    setmemberIsModalVisible(true);
  };
  const fetchMembers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getMembers({
        ...meta,
        page: searchParams.get("page") ? searchParams.get("page") : 1,
        key: sortConfig.key,
        order: sortConfig.direction,
      });
      if (result["members"]) {
        const data = result?.members.map((item) => ({
          ...item,
          checked: selectAll,
        }));
        setmembersList(data);
        setTotalCount(result?.meta.total_count);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refreshPage,
    sortConfig.direction,
    sortConfig.key,
    searchParams.get("page"),
  ]);

  const fetchTemplates = useCallback(async () => {
    try {
      const result = await getTemplates(initialMetaForTable);
      if (result["templates"]) {
        const data = result?.templates.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setTemplatesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchMembers();
  }, [fetchMembers]);
  useEffect(() => {
    fetchTemplates();
  }, []);

  useEffect(() => {
    setSelectedmembers(
      selectAll
        ? membersList.length
        : membersList.reduce((accumulator, item) => {
            if (item.checked) {
              return accumulator + 1;
            } else return accumulator;
          }, 0)
    );
  }, [membersList, selectAll]);
  const handleOpenTemplateModal = () => {
    setIsTemplateModalVisible(true);
  };
  const handleCloseTemplateModal = () => {
    setIsTemplateModalVisible(false);
    setSelectedTemplate("");
  };
  const downloadCSV = async () => {
    try {
      const result = await getExportMembers({
        ...meta,
        key: sortConfig.key,
        order: sortConfig.direction,
      });

      const encodedData = result["members_encoded_data"];

      const decodedData = atob(encodedData);

      const blob = new Blob([decodedData], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "member-data.csv");

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  };
  const debouncedTemplateCallback = useDebouncedTemplateDataCallback();

  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Members"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={
          searchParams.get("page") ? parseInt(searchParams.get("page")) : 1
        }
        onPageChange={handlePageChange}
        selectedItems={selectedmembers}
        isLoading={loading}
        meta={meta}
        setMeta={setMeta}
        handleRefreshPage={handleRefreshPage}
        actionButtons={
          selectedmembers > 0
            ? [
                {
                  label: `Delete ${selectedmembers} Items`,
                  classes: "danger-btn m-0-imp",
                  icon: <TrashSimple size={24} className="me-3" />,
                  handleClick: () => {},
                },
              ]
            : [
                {
                  label:
                    meta.mif_status === "without_policy"
                      ? "Without Policy"
                      : meta.mif_status === "all"
                      ? "Show All"
                      : "Status",
                  selectedFilter: meta.mif_status || "all",
                  handlefilterSelect: (value) => {
                    handleSetMifFilter(value);
                  },
                  dropdown: true,
                  dropdownOptions: [
                    { label: "Show All", value: "all" },
                    { label: "Without Policy", value: "without_policy" },
                  ],
                },
                {
                  label: "Add Members",
                  classes: "primary-btn",
                  icon: <Plus size={24} className="me-3" />,
                  handleClick: handleOpenmemberModal,
                },
              ]
        }
        // actionButtons={
        //   selectedmembers > 0
        //     ? [
        //         // {
        //         //   label: `Delete ${selectedmembers} Items`,
        //         //   classes: 'danger-btn m-0-imp',
        //         //   icon: <TrashSimple size={24} className="me-3" />,
        //         //   handleClick: handleBulkDeleteMembers,
        //         // },
        //       ]
        //     : [
        //         // {
        //         //   label: 'Upload File',
        //         //   classes: 'secondary-btn',
        //         //   icon: <UploadSimple size={24} className="me-3" />,
        //         //   handleClick: () => {},
        //         // },
        //         {
        //           label: 'Export Data',
        //           classes: 'primary-btn',
        //           icon: <DownloadSimple size={24} className="me-3" />,
        //           handleClick: () => {
        //             downloadCSV();
        //           },
        //         },
        //         {
        //           label:
        //             meta.mif_status === 'active'
        //               ? 'Active MIF'
        //               : meta.mif_status === 'without_policy'
        //               ? 'Without Policy'
        //               : 'MIF Status',
        //           selectedFilter: meta.mif_status,
        //           handlefilterSelect: selectedValue => handleSetMifFilter(selectedValue),
        //           dropdown: true,
        //           dropdownOptions: [
        //             {
        //               label: 'Active',
        //               value: 'active',
        //             },
        //             {
        //               label: 'Without Policy',
        //               value: 'without_policy',
        //             },
        //           ],
        //         },
        //       ]
        // }
      >
        <div className="container-fluid ">
          <div className=" overflow-scroll boarder-radius-20px scrollable">
            <table className="table table-rows ">
              {/* <thead className="table-header">
                <tr>
                  <th>
                    <div className="form-check ps-3 mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Date of Birth</th>
                  <th>Phone Number</th>
                  <th>Health Plan</th>
                  <th>Account#</th>
                  {/* <th>MIF Status</th> */}
              {/*<th>ECM</th>
                  <th>
                    <div className="text-center">In Person Surveys</div>
                    <div className="text-center">Completed</div>
                  </th>
                  <th>
                    <div className="text-center">Telephonic Surveys</div>
                    <div className="text-center">Completed</div>
                  </th>
                </tr>
              </thead> */}
              <thead
                className="table-header"
                style={{ backgroundColor: "black" }}
              >
                <tr>
                  {columns.map((column) => (
                    <SortableTableHeader
                      key={column.columnKey}
                      columnKey={column.columnKey}
                      label={column.label}
                      isSortable={column.isSortable}
                      sortConfig={sortConfig}
                      onSortChange={handleSort}
                    />
                  ))}
                </tr>
              </thead>
              <tbody className="table-body">
                {membersList?.map((member, index) => (
                  <tr key={index}>
                    <td className="fw-bold  ">
                      {member?.created_from === "mif" && (
                        <span className="p-2">
                          <List size={24} />
                        </span>
                      )}
                      {member?.created_from === "manually" && (
                        <span className="p-2">
                          <Plus size={24} />
                        </span>
                      )}
                      {member?.created_from === "referrals" && (
                        <span className="p-2">
                          <ArrowsLeftRight size={24} />
                        </span>
                      )}
                      {highlightFirstMatch(member?.name, meta.search)}
                    </td>
                    <td>{member?.follow_up}</td>
                    <td className=" ">{member?.date_of_birth}</td>
                    <td className=" ">{member?.cin}</td>
                    <td className=" ">
                      {capitalizeName(member?.county?.name)}
                    </td>
                    {/* <td className=" ">{highlightFirstMatch(member.phone_number, meta.search)}</td> */}
                    {/* <td className=" ">
                      {highlightFirstMatch(
                        member?.health_plan?.name,
                        meta.search
                      )}
                    </td> */}
                    {/* <td className=" ">{member.account_number}</td> */}
                    {/* <td className=" ">{member.mif_status}</td> */}
                    <td className="fw-bold  ">{member?.policy?.name}</td>
                    <td className="fw-bold  ">{member?.health_plan_name}</td>
                    <td>
                      <div
                        className={`status ${
                          member.mif_status === "active" ? "active" : "inactive"
                        }`}
                      >
                        {member.mif_status === "active" ? "Active" : "Inactive"}
                      </div>
                    </td>
                    <td>
                      <div
                        className={`status ms-3 ${
                          member.enrollment_status === "NEW"
                            ? "Excluded"
                            : member.enrollment_status === "OU"
                            ? "pending"
                            : "pending"
                        }`}
                      >
                        {member.enrollment_status.charAt(0).toUpperCase() +
                          member.enrollment_status.slice(1)}
                      </div>
                    </td>
                    {/* <td className="fw-bold  ">{member?.policy?.name}</td> */}
                    {/* <td className=" ">{highlightFirstMatch(member.account_number, meta.search)}</td> */}
                    {/* <td>
                      <div className={`status ${member.mif_status === 'active' ? 'active' : 'inactive'}`}>
                        {member.mif_status.charAt(0).toUpperCase() + member.mif_status.slice(1)}
                      </div>
                    </td> */}
                    {/* <td>
                      <div
                        className={`status ms-3 ${
                          member.enrollment_status === 'NEW'
                            ? 'Excluded'
                            : member.enrollment_status === 'OU'
                            ? 'pending'
                            : 'pending'
                        }`}
                      >
                        {member.enrollment_status.charAt(0).toUpperCase() + member.enrollment_status.slice(1)}
                      </div>
                    </td> */}
                    {/* <td>{formatDateDiff(member.last_survey_completed)}</td> */}
                    {/* <td className=" ">{member.in_person}</td> */}
                    <td className=" ">{member?.survey_count || ""}</td>
                    <td className="gap-2">
                      <Tooltip title="History">
                        <Scroll
                          size={24}
                          className="cursor-pointer"
                          onClick={() => {
                            navigate(`/members/${member.id}`);
                            localStorage.setItem(
                              "member",
                              JSON.stringify(member)
                            );
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className=" ms-3  cursor-pointer"
                          onClick={() => {
                            setSelectedMember(member);
                            handleOpenmemberModal();
                          }}
                        />
                      </Tooltip>
                    </td>
                    <td>
                      <button
                        className={`secondary-btns cursor-pointer  ${(member.pending_survey &&
                          "pending") ||
                          "Excluded"}  cursor-pointer `}
                        onClick={() => {
                          if (
                            !member.in_progress_survey &&
                            !member.pending_survey
                          ) {
                            setSelectedMemberForSurvey(member);
                            handleOpenTemplateModal(true);
                          } else
                            navigate(`/survey/${member.id}`, { state: member });
                          localStorage.setItem(
                            "member",
                            JSON.stringify(member)
                          );
                        }}
                      >
                        {(member.pending_survey && "Pending Survey") ||
                          (member.in_progress_survey && "In Progress Survey") ||
                          "Start Survey"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>
      {ismemberModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosememberModal}
          heading={`${selectedMember ? "Edit" : "Add"} Member`}
        >
          <Addmemberform
            handleQuestionSubmittion={handlememberSubmission}
            handleClose={handleClosememberModal}
            selectedMember={selectedMember}
          />
        </CustomModal>
      )}

      {isTemplateModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseTemplateModal}
          heading={`Choose Template`}
        >
          <AsyncSelect
            label="Select Template"
            isRequired
            options={templatesList}
            loadOptions={(inputValue) =>
              new Promise((resolve) => {
                debouncedTemplateCallback(inputValue, resolve);
              })
            }
            selectedValue={selectedTemplate}
            placeholder="Select "
            handleChange={(obj) => {
              setSelectedTemplate(obj);
            }}
          />

          <div className="action gap-2">
            <button
              className="secondary-btn w-50"
              type="button"
              onClick={handleCloseTemplateModal}
            >
              Cancel
            </button>
            <button
              className="primary-btn w-50"
              type="button"
              disabled={!selectedTemplate}
              onClick={() => {
                console.log("selectedTemplate", selectedTemplate);
                navigate(`/survey/${selectedMemberForSurvey.id}`, {
                  state: {
                    ...selectedMemberForSurvey,
                    template_id: selectedTemplate?.value,
                  },
                });
              }}
            >
              Start Survey
            </button>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default Member;
